import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppTableDirective } from './directive/app-table.directive';
import { AppTableInputSearchDirective } from './directive/app-table-input-search.directive';
import { AppDataListDirective } from './directive/app-data-list.directive';
// import { AppDataListComponent } from './component/app-data-list/app-data-list.component';
import { AppTimeDirective } from './directive/app-time.directive';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { CoreModule } from '@app/core/core.module';
import { AppFullContentDirective } from './directive/app-full-content.directive';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { AppTableInputFilterDirective } from './directive/app-table-input-filter.directive';
import { AppGroupSelectorComponent } from './component/app-group-selector/app-group-selector.component';
import { AppOperationDaysDirective } from './directive/app-operation-days.directive';
import { AppWorklogComponent } from './component/app-worklog/app-worklog.component';
import { AppUpperCaseDirective } from './directive/app-upper-case.directive';
import { AppDateDirective } from './directive/app-date.directive';
import { AppInputDecimalThreeDigitsDirective } from './directive/app-input-decimal-three-digits.directive';
import { AppNumberDirective } from './directive/app-number.directive';
import { SSIMDateErrorsComponent } from './component/ssimdate-errors/ssimdate-errors.component';
import { OperationDaysPipe } from './pipes/operation-days.pipe';
import { FormDateErrorComponent } from './component/form-date-error/form-date-error.component';
import { FormTimeErrorComponent } from './component/form-time-error/form-time-error.component';
import { AppMovementActionDirective } from './directive/app-movement-action.directive';
import { AppFlightNumberDirective } from './directive/app-flight-number.directive';
import { AppTruncatePipe } from './pipes/app-truncate.pipe';
import { AppInputPasswordDirective } from './directive/app-input-password.directive';
import { AppInputListDirective } from './directive/app-input-list.directive';
import { CamelCasePipe } from './pipes/camel-case.pipe';
import { InputFillDirective } from './directive/input-fill.directive';
import { AppLowerCaseDirective } from './directive/app-lower-case.directive';

@NgModule({
  declarations: [
    AppTableDirective,
    AppTableInputSearchDirective,
    AppDataListDirective,
    // AppDataListComponent,
    AppTimeDirective,
    AppFullContentDirective,
    AppTableInputFilterDirective,
    AppGroupSelectorComponent,
    AppOperationDaysDirective,
    AppWorklogComponent,
    AppUpperCaseDirective,
    AppLowerCaseDirective,
    AppDateDirective,
    AppInputDecimalThreeDigitsDirective,
    AppNumberDirective,
    SSIMDateErrorsComponent,
    OperationDaysPipe,
    FormDateErrorComponent,
    FormTimeErrorComponent,
    AppMovementActionDirective,
    AppFlightNumberDirective,
    AppTruncatePipe,
    AppInputListDirective,
    CamelCasePipe,
    InputFillDirective
  ],
  imports: [
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    CommonModule,
    CoreModule,
    NgbModule,
    TranslateModule
  ],
  exports: [
    AppTableDirective,
    AppTableInputSearchDirective,
    AppDataListDirective,
    // AppDataListComponent,
    AppTimeDirective,
    AppDateDirective,
    AppOperationDaysDirective,
    AppFullContentDirective,
    AppTableInputFilterDirective,
    AppGroupSelectorComponent,
    AppUpperCaseDirective,
    AppLowerCaseDirective,
    AppWorklogComponent,
    AppInputDecimalThreeDigitsDirective,
    AppNumberDirective,
    SSIMDateErrorsComponent,
    FormDateErrorComponent,
    FormTimeErrorComponent,
    AppMovementActionDirective,
    AppFlightNumberDirective,
    AppInputListDirective,
    AppTruncatePipe,
    AppInputPasswordDirective,
    InputFillDirective,
    CamelCasePipe,
    TranslateModule
  ]
})
export class SharedModule { }
